/* SettingsData - Model for the user settings details */
export class SettingsDetails {
    taskName: string;
    functionType: string;
    functionName: string;
    uniqueId: string;
    settings: any;
    updatedTimeStamp: string;
    dataSize: string;
    isAvailable: boolean;
    isSaveNotification: boolean;
    isForAllSite?: boolean;
}
